import { render } from "./JsonPasteModal.vue?vue&type=template&id=fdd692c6"
import script from "./JsonPasteModal.vue?vue&type=script&lang=js"
export * from "./JsonPasteModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__